import React from "react";
import TextField from "@mui/material/TextField";
import Box from "@mui/material/Box";
import { makeStyles } from "tss-react/mui";
import Grid from "@mui/material/Grid";

const useStyles = makeStyles()({
  formContainer: {
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    justifyContent: "center",
    width: "100%",
    padding: "0px 15px",
    textAlign: "center",
    minHeight: "250px",
    "& .Mui-disabled": {
      color: "#FFFFFF",
    },
    "& .MuiButtonBase-root:hover": {
      backgroundColor: "#2B8AAA",
    },
  },
});

export default function AddOIDC({ idpName, setIdpName, MetaDataURL, setMetaDataURL }) {
  const { classes } = useStyles();

  return (
    <Box sx={{ width: "100%" }} component="form" className={classes.formContainer}>
      <Grid container spacing={2} style={{ marginTop: "10px" }}>
        <Grid size={12}>
          <TextField
            margin="dense"
            value={idpName}
            onChange={(e) => setIdpName(e.target.value)}
            fullWidth
            label="Name"
            autoFocus
            placeholder="Enter a user friendly name to show on the Login screen"
            required
          />
        </Grid>
        <Grid size={12}>
          <TextField
            margin="dense"
            value={MetaDataURL}
            onChange={(e) => setMetaDataURL(e.target.value)}
            label="Metadata Address"
            placeholder="The discovery point for obtaining metadata (typically [AuthorityURL]/.well-known/openid-configuration)"
            required
            multiline={true}
            minRows={3}
            maxRows={5}
            fullWidth
          />
        </Grid>
      </Grid>
    </Box>
  );
}
